/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { EmptyState as StyledEmptyState } from '../../styled';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  backgroundImage?: string;
  children?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ backgroundImage, children }) => {
  const bgUrl =
    typeof backgroundImage === 'string'
      ? backgroundImage
      : (backgroundImage as any)?.src || (backgroundImage as any)?.default || '';

  const backgroundStyle =
    bgUrl !== ''
      ? {
          backgroundImage: `url('${bgUrl}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative' as const,
        }
      : {};

  return (
    <StyledEmptyState style={backgroundStyle}>
      {bgUrl && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: 'inherit',
          }}
        />
      )}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* {icon && (
          <EmptyIcon style={{ color: backgroundImage ? 'white' : undefined, marginBottom: '15px' }}>{icon}</EmptyIcon>
        )} */}
        {/* <EmptyTitle style={{ color: backgroundImage ? 'white' : undefined }}>{title}</EmptyTitle>
        <EmptyDescription style={{ color: backgroundImage ? 'rgba(255, 255, 255, 0.9)' : undefined }}>
          {description}
        </EmptyDescription> */}
        {children}
      </div>
    </StyledEmptyState>
  );
};
